<div class="layout-row flex full-height">

  <div class="flex-20 layout-column price-plans-bundle-hierarchy overflow-auto">
    <span class="br-body-2 primary-100 font-weight-600 padding-20 padding-bottom-10" translate>Programs</span>

    <app-price-plans-bundle-hierarchy
      class="flex padding-left-20 padding-right-20"
      [pricePlansBundleHierarchy]="pricePlansBundleHierarchy"
      [selectedPricePlanId]="selectedPricePlanId"
      (selectPricePlanEvent)="onSelectPricePlan($event)"
      (viewPricePlanDrillDownEvent)="onViewPricePlanDrillDown($event)">
    </app-price-plans-bundle-hierarchy>
  </div>

  <div class="layout-column flex padding-20">
    <app-price-plan-details-view *ngIf="pricePlanDetails"
                                 class="flex full-height"
                                 [pricePlanDetails]="pricePlanDetails"
                                 [selectedIds]="selectedAccountIds"
                                 (setAsDefaultEvent)="onSetPricePlanAsDefault($event)"
                                 (createPricePlanChildEvent)="onCreatePricePlanChild($event)"
                                 (duplicatePricePlanEvent)="onDuplicatePricePlan($event)"
                                 (editPricePlanEvent)="onEditPricePlan($event)"
                                 (updatePricePlanAccountsEvent)="onUpdatePricePlanAccounts($event)"
                                 (importProgramSettingsEvent)="onImportProgramSettings()"
                                 (onExportEvent)="onExport($event.exportType, $event.event)"
                                 (onSelectedIdsChange)="onSelectedAccountIdsChange($event)">
    </app-price-plan-details-view>
  </div>

</div>
